import type { ReviewAnswer } from "../types";
import FormAnswerItem from "./form-answer-item";

interface FormAnswersSectionProps {
	answers: ReviewAnswer[];
}

export default function FormAnswersSection({ answers }: FormAnswersSectionProps) {
	// Answers are returned pre-sorted from the backend
	const sortedAnswers = answers;

	return (
		<div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
			{/* Header */}
			<div className="flex items-start gap-3 p-6">
				<div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center shrink-0">
					<svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={1.5}
							d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
						/>
					</svg>
				</div>
				<div>
					<h3 className="text-t-15 font-semibold text-primary">Form Responses</h3>
					<p className="text-t-13 text-tertiary mt-0.5">Questions and answers from the submission form</p>
				</div>
			</div>

			{/* Q&A List */}
			<div className="border-t border-gray-200 divide-y divide-gray-200">
				{sortedAnswers.map((answer) => (
					<FormAnswerItem key={answer.id} answer={answer} />
				))}
			</div>

			{/* Non-editable message */}
			<div className="border-t border-gray-200 p-6 pt-3">
				<p className="text-xs text-tertiary">Form responses cannot be changed for reviews submitted via forms.</p>
			</div>
		</div>
	);
}
